import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ModalHeaderTitle from "layouts/users/AddEditUserModal/Header";
import { Formik, Form as FormikForm } from "formik";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import { StyledEngineProvider } from "@mui/material/styles";
import { NewVoucher, Voucher } from "types/Voucher";

type AddViewModalProp = {
  open: boolean;
  handleClose: () => void;
  isView: boolean;
  selectedRow?: Voucher;
  createNewVoucher: (voucher: NewVoucher) => void;
};
const initialValues: NewVoucher = {
  label: "",
  business: "",
  price: "",
  total_items: "",
  type: "Multi Buy",
  voucher_condition: ""
};
const AddViewVoucherModal: React.FC<AddViewModalProp> = (props) => {
  const { open, handleClose, isView, createNewVoucher } = props;
  const formikRef = useRef<any>(null);
  const businessId = localStorage.getItem("stmpz-business-id");

  const handleOnClose = (_: {}, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") {
      console.info("Backdrop is clicked");
    } else {
      handleClose();
    }
  };

  const onSubmit = (values) => {
    createNewVoucher(values);
  };

  return (
    <StyledEngineProvider injectFirst>
      <Dialog
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableEscapeKeyDown={true}
        onBackdropClick={(event) => {
          event.stopPropagation();
          return false;
        }}
      >
        <ModalHeaderTitle id="customized-dialog-title" onClose={handleClose}>
          {`${isView ? "View" : "New"} Voucher`}
        </ModalHeaderTitle>{" "}
        <DialogContent dividers>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            innerRef={formikRef}
          >
            {({ values, handleBlur, handleChange, setFieldValue }) => (
              <FormikForm>
                <MDBox mb={2} ml={1} display={"flex"}>
                  <MDBox mr={5} width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Business"
                      name="business"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled
                      value={businessId}
                    />
                  </MDBox>
                </MDBox>
                <MDBox mb={2} ml={1} display={"flex"}>
                  <MDBox mr={5} width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Title"
                      name="label"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.label}
                    />
                  </MDBox>
                  <MDBox width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Type"
                      name="type"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.type}
                    />
                  </MDBox>
                </MDBox>
                <MDBox mb={2} ml={1} display={"flex"}>
                  <MDBox mr={5} width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Price"
                      name="price"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.price}
                    />
                  </MDBox>
                  <MDBox width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Quantity"
                      name="total_items"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.total_items}
                    />
                  </MDBox>
                </MDBox>
                <MDBox mb={2} ml={1} display={"flex"}>
                  <MDBox mr={5} width={"50%"}>
                    <MDInput
                      fullWidth
                      type="text"
                      label="Voucher Conditions"
                      name="voucher_condition"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.voucher_condition}
                    />
                  </MDBox>
                </MDBox>
              </FormikForm>
            )}
          </Formik>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              //Trigger formik button as outside the form
              if (formikRef.current) {
                formikRef.current.handleSubmit();
              }
            }}
          >
            {`${isView ? "Resend" : "Create"}`}
          </Button>
        </DialogActions>
      </Dialog>
    </StyledEngineProvider>
  );
};
export default AddViewVoucherModal;
